import { render, staticRenderFns } from "./hotel-policy-list.vue?vue&type=template&id=25cdcd23"
import script from "./hotel-policy-list.vue?vue&type=script&lang=ts"
export * from "./hotel-policy-list.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports